import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobService } from '../services/sections/job/job.service';
import { Job } from '../models/job.model';
import { JobStatusTypes } from '../models/enum/job-status-types.enum';

@Injectable({
	providedIn: 'root'
})
export class JobsResolver implements Resolve<Observable<Job>> {
	constructor(
		private router: Router,
		private jobsService: JobService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.jobsService
			.getJobDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap((result) => {
					GlobalSettingsService.preferencesPayload.job = result;
					GlobalSettingsService.isJobCompletedStatusVisible = result.statusId === JobStatusTypes.Completed;
				})
			);
	}
}
